import axios from 'axios'

import { DATAMASTER_ENDPOINT } from '../../endpoints'

export async function getAuto(id, queryString = '', { files = false } = {}) {
  const auto = await axios(`${DATAMASTER_ENDPOINT}/${id}${queryString}`).then((res) => res.data.data)
  return auto
}

export async function getAutoComparador(id) {
  const auto = await getAuto(id)
  return auto
}
